export default __webpack_public_path__ + "static/media/r10.d9bd1753.jpg";